<template>
	<template v-if="visible">
		<div v-if="notRaw" :class="blockStyle" :style="style">
			<template v-for="(item, idx) in block.items" :key="idx">
				<component :is="componentOfPart(item)" :part="partRef(item)" :data="localData" :readonly="ro" :viewmode="vm"></component>
			</template>
		</div>
		<template v-else>
			<template v-for="(item, idx) in block.items" :key="idx">
				<component :is="componentOfPart(item)" :part="partRef(item)" :data="localData" :readonly="ro" :viewmode="vm"></component>
			</template>
		</template>
	</template>
</template>

<script setup lang="ts">
import {computed} from "vue";
import useContainer, {type ContainerProps, containerProps} from "./Container";
import type {Block} from "@t/fd/layout/Block";

const uprops = defineProps({
    ...containerProps,
});
const props = uprops as ContainerProps;
const block = computed<Block>(() => props.part as Block);

const {componentOfPart, partRef, localData, ro, vm, visible, clazz, style} = useContainer(props);

const notRaw = computed(() => block.value.style !== "raw");

const blockStyle = computed(() => {
    const classes = ["fd-block"];
    if (block.value.style) {
        classes.push("fd-style-" + block.value.style);
    }
    if (clazz.value) classes.push(clazz.value)
    return classes;
});
</script>

<style>
.fd-style-list {
	border-radius: 10px;
	overflow: hidden;
	margin-left: var(--gap);
	margin-right: var(--gap);
	border: var(--hair) solid var(--border-color);
	background-color: var(--item-bg);
	padding-left: var(--gap);
}

.fd-style-transparent-list {
	overflow: hidden;
	margin-left: var(--gap);
	margin-right: var(--gap);
	background-color: transparent;
	padding-left: var(--gap);
}

.fd-style-list > div {
	border-bottom: var(--hair) solid var(--border-color);
}

.fd-style-list > div:last-child {
	border-bottom: none;
}
</style>
